import * as React from 'react';
import * as styles from './styles.css';

interface ICookieBannerProps {
  onAgreementClick: () => void;
  onClose: () => void;
  onReject: () => void;
  timerDurationMs?: number;
}

export const CookieBanner: React.FC<ICookieBannerProps> = ({
  onAgreementClick,
  onClose,
  onReject,
  timerDurationMs,
}) => (
  <section data-cookie-banner className={styles.banner} aria-label="Использование Cookies">
    <h3 className={styles.title}>Мы используем Cookies</h3>
    <p className={styles.description}>
      Файлы Cookie помогают сайту работать корректно, запоминать ваши настройки и делать контент удобнее.
    </p>
    <button type="button" className={styles.agreement} onClick={onAgreementClick}>
      Политика использования Cookies
    </button>
    <div className={styles.actions}>
      <button type="button" className={styles.accept} onClick={onClose}>
        Принять
      </button>
      <button type="button" className={styles.secondary} onClick={onAgreementClick}>
        Настроить
      </button>
      <button type="button" className={styles.secondary} onClick={onReject}>
        Отклонить
      </button>
    </div>
    {timerDurationMs !== undefined && (
      <div className={styles.timer} aria-hidden="true">
        <div className={styles['timer-progress']} style={{ animationDuration: `${timerDurationMs}ms` }} />
      </div>
    )}
  </section>
);

CookieBanner.displayName = 'CookieBanner';
